/*
 * @Author: Tango
 * @Date: 2020-12-24 14:23:28
 * @Last Modified by: Roger
 * @Last Modified time: 2021-02-04 11:02:50
 */
<template>
  <div id="planning">
    <a-tabs class="plan-tab"
      :class="{'is-unread': myPlanUnread}"
      :defaultActiveKey="defaultPlanType"
      @change="handleGetPlanByType">
      <a-tab-pane key="1" tab="企划列表"></a-tab-pane>
      <a-tab-pane key="2" tab="我参与的企划"></a-tab-pane>
      <!-- 我参与的企划列表 -->
      <a-dropdown v-if="isMyPlanType" slot="tabBarExtraContent" style="margin-right: 20px">
        <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
          <!-- {{ contributionStatusMap[queryParams.status].text }} -->
          <template v-if="queryParams.status === '-1'">全部</template>
          <template v-if="queryParams.status === '1'">待评选</template>
          <template v-if="queryParams.status === '2'">评选中</template>
          <template v-if="queryParams.status === '3' && queryParams.is_choice === '1'">投稿获选</template>
          <template v-if="queryParams.status === '3' && queryParams.is_choice === '0'">投稿落选</template>
          <a-icon type="down" />
        </a>
        <a-menu slot="overlay" @click="handleContributionStatusChange">
          <a-menu-item v-for="(value, key) in contributionStatusMap" :key="key">
            <a href="javascript:;">{{ value.text }}</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <!-- 企划列表 -->
      <a-dropdown v-else slot="tabBarExtraContent" style="margin-right: 20px">
        <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
          {{ statusMap[queryParams.status].text }}
          <a-icon type="down" />
        </a>
        <a-menu slot="overlay" @click="handleStatusChange">
          <a-menu-item v-for="(value, key) in statusMap" :key="key">
            <a href="javascript:;">{{ value.text }}</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </a-tabs>
    <div class="content">
      <div class="plan-list" v-if="pagination.total > 0">
        <a-spin :spinning="spinning">
          <div class="plan-item" 
            v-for="(item, index) in planList" 
            :key="index" @click="goDetail(item)"
          >
            <h4 class="name" :class="{'is-unread': item.show_read === 1 && isMyPlanType}">{{ item.name }}</h4>
            <div class="right-info">
              <span class="info"
              >已有 <i class="num">{{ item.works_count }}</i> 个作品参与投稿</span
              >
              <!-- @0 表示未开始 用户侧不显示该状态 -->
              <span v-if="isMyPlanType && item.status !== 0" class="status-step" style="margin-left: 20px">
                <span class="status-step__1" v-if="item.status === 1">待评选</span>
                <span class="status-step__2" v-if="item.status === 2">评选中</span>
                <span class="status-step__3" v-if="item.status === 3 && item.is_choice === 1">投稿获选</span>
                <span class="status-step__4" v-if="item.status === 3 && item.is_choice === 0">投稿落选</span>
              </span>
              <span v-else class="status-button" style="margin-left: 20px">
                <a-badge :status="statusMap[item.status].status" :text="statusMap[item.status].text" />
              </span>
            </div>
            <div class="label" v-if="item.label">
              <p>
                <span class="label-item" v-for="(label, i) in item.label.split(',')" :key="i">{{ label }}</span>
              </p>
              <span class="label-date" v-if="isMyPlanType">投稿时间：{{ item.contribute_time }}</span>
            </div>
            <div class="plan-author" v-if="item.avatar || item.username">
              <img class="plan-author__avatar"
                v-if="item.avatar" 
                :src="`${constv.QINIU_IMAGE_CND_URL}${item.avatar}`"
                :alt="item.username" />
              <div class="plan-author__nickname" v-if="item.username">{{ item.username }}</div>
            </div>
            <p class="date" style="margin-bottom: 16px">
              <span>作品类型：{{ categoryMap[item.category] }}</span>
            </p>
            <p class="date">
              <span>征集时间：{{ item.start_time }} 至 {{ item.end_time }}</span>
            </p>
            <p class="line"></p>
            <p class="detail hide-text-2">
              {{ item.summary }}
            </p>
            <img v-if="item.is_contribute === 1" class="plan-item__icon" src="@/assets/img/icon_tag_ join@3x.png" alt="企划参加标识">
          </div>
        </a-spin>
        <div style="text-align: right; margin-top: 36px;">
          <a-pagination
            v-if="pagination.total > 10"
            :current="pagination.currentPage"
            :total="pagination.total"
            :default-page-size="10"
            :show-total="(total) => `共 ${Math.ceil(total / 10)} 页`"
            @change="allPageChange"
          />
        </div>
      </div>
      <div v-else class="empty">
        <span>{{ isMyPlanType && planList.length === 0 ? '未参与过任何企划' : '暂无企划' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import contentTitle from '@/components/Zpace/common/contentTitle'
const MY_PLAN_TYPE = '2' // 我参与的企划
export default {
  name: 'Planning',
  data () {
    return {
      defaultPlanType: '1',
      statusMap: {
        '-1': {
          text: '全部',
          status: 'default'
        },
        '1': {
          text: '进行中',
          status: 'processing'
        },
        '2': {
          text: '评选中',
          status: 'success'
        },
        '3': {
          text: '已结束',
          status: 'default'
        }
      },
      contributionStatusMap: {
        '-1': {
          text: '全部',
          status: 'default'
        },
        '1': {
          text: '待评选',
          status: 'processing'
        },
        '2': {
          text: '评选中',
          status: 'success'
        },
        '3': {
          text: '投稿获选',
          status: 'warning'
        },
        '4': {
          text: '投稿落选',
          status: 'error'
        },
      },
      categoryMap: {
        // （1-场景 2-贴图 3-人设背景）
        1: '场景',
        2: '贴图',
        3: '人设背景'
      },
      queryParams: {
        // page: sessionStorage.getItem('planPage') - 0 || 1,
        page: 1,
        pagesize: 10,
        status: sessionStorage.getItem('planStatus') || '-1',
        is_choice: sessionStorage.getItem('planIsChoice'),
      },
      pagination: {
        // currentPage: sessionStorage.getItem('planPage') - 0 || 1,
        currentPage: 1,
        total: 0
      },
      planList: [],
      spinning: false
    }
  },
  components: {
    contentTitle
  },
  computed: {
    isMyPlanType () { return this.defaultPlanType === MY_PLAN_TYPE},
    ...mapState({
      myPlanUnread: ({ app }) => app.myPlanUnread
    }),
  },
  async created () {
    const currentType =  this.$route.query.type
    if (currentType) {
      this.defaultPlanType = currentType
    }
    this.handleGetPlanByType()
  },
  methods: {
    ...mapActions(['GetUnreadMenuList']),
    handleGetPlanByType (key) {
      if (key) {
        const initStatus = '-1'
        this.defaultPlanType = key
        this.queryParams.page = 1
        this.queryParams.status = initStatus // TODO: 后续用两个状态标识，现混用，切换时重置，因为两个列表的状态不一样
        sessionStorage.setItem('planStatus', initStatus)
        this.pagination.currentPage = 1
      }
      const _key = this.defaultPlanType

      switch (_key) {
        case '1': {
          this.queryParams.is_choice = null
          sessionStorage.removeItem('planIsChoice')
          this.handleGetPlanList()
          break;
        };
        case '2': {
          this.handleGetMyPlanList()
          break;
        }
      }
      this.GetUnreadMenuList()
      this.$router.replace({ name: 'planning', query: { type: _key }})
    },
    handleGetPlanList () {
      this.spinning = true
      this.$api.planning.getPlanningList(this.queryParams)
        .then((res) => {
          if (res.status === 'ok') {
            this.spinning = false
            this.pagination.total = res.data.count
            this.planList = res.data.list
          }
        })
    },
    handleGetMyPlanList () {
      this.spinning = true
      this.$api.planning.getMyPlanList(this.queryParams)
        .then((res) => {
          if (res.status === 'ok') {
            this.spinning = false
            this.pagination.total = res.data.count
            this.planList = res.data.list
          }
        })
    },
    async allPageChange (page, pageSize) {
      this.pagination.currentPage = page
      sessionStorage.setItem('planPage', page)
      this.queryParams = Object.assign(this.queryParams, {
        page,
        pagesize: pageSize
      })
      await this.handleGetPlanByType()
    },
    goDetail (item) {
      if (this.isMyPlanType) {
        this.$router.push({ path: `/manage/planContributeInfo/${item.package_id}`})
      } else {
        this.$router.push({ path: `/manage/planDetail/${item.id}`})
      }
    },
    handleContributionStatusChange (e) {
      let status = e.key
      let isChoice
      switch (status) {
        case '3': {
          isChoice = '1'
          break;
        }
        case '4': {
          status = '3'
          isChoice = '0'
          break;
        }
        default: {
          isChoice = null
        }
      }
      this.queryParams.page = 1
      this.pagination.currentPage = 1
      this.queryParams.status = status
      this.queryParams.is_choice = isChoice
      sessionStorage.setItem('planStatus', status)
      if (isChoice) {
        sessionStorage.setItem('planIsChoice', isChoice)
      }
      sessionStorage.setItem('planPage', '1')
      this.handleGetMyPlanList()
    },
    handleStatusChange (e) {
      this.queryParams.page = 1
      this.pagination.currentPage = 1
      this.queryParams.status = e.key
      sessionStorage.setItem('planStatus', e.key)
      sessionStorage.setItem('planPage', '1')
      this.handleGetPlanList()
    }
  }
}
</script>

<style lang="less" scoped>
#planning {
  background-color: #ffffff;
  min-height: 580px;
  .plan-tab {
    /deep/ .ant-tabs-nav .ant-tabs-tab {
      padding: 14px 12px;
    }
    /deep/ .ant-tabs-bar {
      margin-bottom: 0;
    }
    &.is-unread {
      /deep/ .ant-tabs-nav .ant-tabs-tab {
      &:last-child {
        &::after {
          position: absolute;
          content: '';
          width: 6px;
          height: 6px;
          top: 12px;
          right: 6px;
          background: #F5222D;
          border-radius: 50%;
        }
      }
    }
    }
  }
  .content {
    padding: 24px;
    .plan-list {
      line-height: 1;
      .plan-item {
        width: calc(~'50% - 12px');
        padding: 20px;
        display: inline-block;
        border: 1px solid #f2f2f2;
        border-radius: 8px;
        position: relative;
        transition: all ease .3s;
        box-shadow: 0 0 3px rgba(161, 175, 201, 0.16);
        cursor: pointer;
        &:not(:last-child){
          margin-bottom: 24px;
        }
        &:hover {
          border: 1px solid white;
          box-shadow: 0 0 3px #ff7401;
        }
        &:nth-child(2n) {
          margin-left: 24px;
        }
        &__icon {
          position: absolute;
          top: -1px;
          left: -1px;
          width: 40px;
          height: 40px;
        }
        .right-info {
          position: absolute;
          right: 20px;
          top: 20px;
          font-size: 12px;
          .status-step {
            font-size: 12px;
            color: #999;
            line-height: 24px;
            padding: 3px 10px;
            border: 1px solid #f2f2f2;
            border-radius: 24px;
            &__1 {
              color: #ff7401;
            }
            &__2 {
              color: #3097EC;
            }
            &__3 {
              color: #6CAE4C;
            }
            &__4 {
              color: #BBBBBB;
            }
          }
          .info {
            color: #999999;
            .num {
              color: #ff7401;
            }
          }
        }
        &.hide-text-2 {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .name {
          position: relative;
          line-height: 1;
          color: #333333;
          font-size: 16px;
          margin-bottom: 16px;
          padding-left: 2px;
          &.is-unread {
            padding-left: 16px;
            &::before {
              position: absolute;
              content: '';
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 8px;
              height: 8px;
              background: #F5222D;
              border-radius: 50%;
            }
          }
        }
        .label {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          .label-item {
            border: 1px solid #e5e5e5;
            border-radius: 12px;
            color: #999999;
            padding: 4px 10px;
            display: inline-block;
            margin-right: 12px;
            box-sizing: border-box;
            font-size: 12px;
            line-height: 1;
          }
          .label-date {
            font-size: 12px;
            color: #999;
          }
        }
        .plan-author {
          display: inline-flex;
          margin-bottom: 16px;
          font-size: 12px;
          align-items: center;
          color: #999;
          &__avatar {
            width: 24px;
            height: 24px;
            border: 1px solid #E5E5E5;
            border-radius: 50%;
            margin-right: 8px;
          }
        }
        .date {
          font-size: 12px;
          color: #999999;
        }
        .line {
          margin: 24px 0 20px;
          width: 100%;
          height: 1px;
          background-image: linear-gradient(to right, #e5e5e5 0%, #e5e5e5 40%, transparent 60%);
          background-size: 10px 1px;
          background-repeat: repeat-x;
        }
        .detail {
          height: 40px;
          font-size: 14px;
          color: #999999;
          line-height: 22px;
        }
      }
    }
    .empty {
      height: 520px;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 18px;
        color: #999999;
      }
    }
  }
}
</style>
